// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2F7TD","log":"ModalInventoryLogs_log__3_6yR","date":"ModalInventoryLogs_date__PAFm7","userName":"ModalInventoryLogs_userName__16LuI"};